import React, { Fragment, useCallback } from "react";
import { useState, useEffect, useRef, useMemo, useContext } from "react";
import { v4 } from "uuid";
import style from "./App.module.scss";
import { useJsApiLoader } from '@react-google-maps/api';
import Cookies from 'universal-cookie';
import AppConfig from './AppConfig';
import { GameProvider, GameContext } from "./GameContext";
//import Login from "./pages/Login";
import TabList from "./comm/global/components/TabList";
import Tab0 from "./pages/Tab0/Tab0";
import Tab1 from "./pages/Tab1/Tab1";
import Tab2 from "./pages/Tab2/Tab2";
import Tab3 from "./pages/Tab3/Tab3";
import Tab4 from "./pages/Tab4/Tab4";
import Tab5 from "./pages/Tab5/Tab5";
import MenuItem from "./comm/global/components/MenuItem";
import AlertCustom from "./Modal/AlertCustom";
//tab0
import SearchTagFilter from "./comm/global/components/SearchTagFilter";
import PotDetail from "./Modal/Tab0/PotDetail";
import SavePot from "./Modal/Tab0/SavePot";
import NewPotFolder from "./Modal/Tab0/NewPotFolder";
import CreateNewPot from "./Modal/Tab0/CreateNewPot";
import OpenPotList from "./Modal/Tab0/OpenPotList";
import ViewFolder from "./Modal/Tab0/ViewFolder";
import EditPotList from "./Modal/Tab0/EditPotList";
import EditPotListAction from "./Modal/Tab0/EditPotListAction";
import SelFolder from "./Modal/Tab0/SelFolder";

import NewEvent from "./Modal/Tab1/NewEvent";
import SelectPot from "./Modal/comm/SelectPot";
import SearchMapModal from "./Modal/Tab1/SearchMapModal";
import SelectTag from "./Modal/comm/SelectTag";
import { fetchGet, fetchPost, loadJson } from "./comm/comm";
import EventDetail from "./Modal/Tab1/EventDetail";
import EditSchedule from "./Modal/Tab1/EditSchedule";
import EditNotice from "./Modal/Tab1/EditNotice";
import AddLink from "./Modal/comm/AddLink";
import ShareLog from "./Modal/Tab2/ShareLog";
import SendInvite from "./Modal/Tab1/SendInvite";
import EventList from "./Modal/Tab1/EventList";
import Capture from "./Modal/Tab2/Capture";
import Collaborative from "./Modal/Tab2/Collaborative";
import FriendSearch from "./Modal/Tab2/FriendSearch";
import ViewPhoto from "./Modal/Tab2/ViewPhoto";
import OtherArea from "./Modal/Tab2/OtherArea";
import { Portal } from "@mui/material";
import PhotoPreview from "./Modal/Tab2/PhotoPreview";
import NewPhoto from "./Modal/Tab2/NewPhoto";
import MoreFriendView from "./Modal/comm/MoreFriendView";
import AddMember from "./Modal/comm/AddMember";
import Invite from "./pages/External/Invite";
import CollectMemories from "./Modal/comm/CollectMemories";
import PayStar from "./Modal/comm/PayStar";
import NewOtherEvent from "./Modal/Tab2/NewOtherEvent";
import OptionSelector from "./Modal/comm/OptionSelector";
import Setting from "./Modal/Tab4/Setting";
import SettingProfile from "./Modal/Tab4/SettingProfile";
import EditProfile1 from "./Modal/Tab4/EditProfile1";
import EditPassword from "./Modal/Tab4/EditPassword";
import SendLostPassword from "./Modal/Tab4/SendLostPassword";
import SetNewPassword from "./Modal/Tab4/SetNewPassword";
import SetProfileIcon from "./Modal/Tab4/SetProfileIcon";
import FixPhoto from "./Modal/Tab4/FixPhoto";
import SettingPermissions from "./Modal/Tab4/SettingPermissions";
import SendFriendInvite from "./Modal/Tab4/SendFriendInvite";
import Contact from "./Modal/Tab4/Contact";
import Terms from "./Modal/Tab4/Terms";
import Statistics from "./Modal/Tab4/Statistics";
import FriendList from "./Modal/Tab4/FriendList";
import Coupon from "./Modal/Tab4/Coupon";
import FriendPage from "./Modal/Tab4/FriendPage";
import Notice from "./Modal/Tab4/Notice";
import CheckUser from "./Modal/Tab4/CheckUser";
import AddFriend from "./Modal/Tab3/AddFriend";
import Charity from "./Modal/Tab3/Charity";
import Rank from "./Modal/Tab3/Rank";
import apiManager from './ApiManager';
import Tab1Template from "./Modal/comm/Tab1Template";
import Tab2Template from "./Modal/comm/Tab2Template";
import BottomAlert from "./Modal/comm/BottomAlert";
import Loading from "./Modal/comm/Loading";
import PhotoFeeling from "./Modal/Tab2/PhotoFeeling";
import axios from 'axios'
import InviteMember from "./Modal/comm/InviteMember";
import Invitations from "./Modal/Tab4/Invitations";
import UploadAni from "./Modal/Tab2/UploadAni";
import Join from "./Modal/Tab2/Join";
import JoinRequest from "./Modal/Tab4/JoinRequest";
const libraries = ['places'];
export default function App() {

  const { init, firstLoading, userData, preProcessEvent } = useContext(GameContext);
  const [loginData, set_loginData] = useState(null);
  const [isLogin, set_isLogin] = useState(false);
  const [modalType, setModalType] = useState([]);
  const [menuVisiable, set_menuVisiable] = useState(true);
  const [prePage, set_prePage] = useState(null);
  const listeners = useRef([]);

  const params = new URLSearchParams(window.location.search);
  const [screenId, set_screenId] = useState({
    ind: 1, screenArg: {
      type: ""
    }
  });

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: libraries,
    language: "zh-TW",
  });

  const menuList = [
    "探索",
    "揪團基地",
    "野放成就",
    "世界",
    "我的",
  ];
  const componentMap = {
    "SearchTagFilter": { modal: SearchTagFilter, name: "SearchTagFilter" }, "PotDetail": { modal: PotDetail, name: "PotDetail" }, "SavePot": { modal: SavePot, name: "SavePot" }, "NewPotFolder": { modal: NewPotFolder, name: "NewPotFolder" }, "CreateNewPot": { modal: CreateNewPot, name: "CreateNewPot" }, "OpenPotList": { modal: OpenPotList, name: "OpenPotList" }, "ViewFolder": { modal: ViewFolder, name: "ViewFolder" },
    "EditPotList": { modal: EditPotList, name: "EditPotList" }, "AlertCustom": { modal: AlertCustom, name: "AlertCustom" }, "EditPotListAction": { modal: EditPotListAction, name: "EditPotListAction" }, "SelFolder": { modal: SelFolder, name: "SelFolder" }, "NewEvent": { modal: NewEvent, name: "NewEvent" }, "SelectPot": { modal: SelectPot, name: "SelectPot" }, "SearchMapModal": { modal: SearchMapModal, name: "SearchMapModal" }, "SelectTag": { modal: SelectTag, name: "SelectTag" },
    "EventDetail": { modal: EventDetail, name: "EventDetail" }, "EditSchedule": { modal: EditSchedule, name: "EditSchedule" }, "EditNotice": { modal: EditNotice, name: "EditNotice" }, "AddLink": { modal: AddLink, name: "AddLink" }, "ShareLog": { modal: ShareLog, name: "ShareLog" }, "EventList": { modal: EventList, name: "EventList" }, "SendInvite": { modal: SendInvite, name: "SendInvite" }, "Capture": { modal: Capture, name: "Capture" }, "Collaborative": { modal: Collaborative, name: "Collaborative" },
    "FriendSearch": { modal: FriendSearch, name: "FriendSearch" }, "ViewPhoto": { modal: ViewPhoto, name: "ViewPhoto" }, "OtherArea": { modal: OtherArea, name: "OtherArea" }, "PhotoPreview": { modal: PhotoPreview, name: "PhotoPreview" }, "NewPhoto": { modal: NewPhoto, name: "NewPhoto" }, "MoreFriendView": { modal: MoreFriendView, name: "MoreFriendView" }, "AddMember": { modal: AddMember, name: "AddMember" }, "CollectMemories": { modal: CollectMemories, name: "CollectMemories" },
    "PayStar": { modal: PayStar, name: "PayStar" }, "NewOtherEvent": { modal: NewOtherEvent, name: "NewOtherEvent" }, "OptionSelector": { modal: OptionSelector, name: "OptionSelector" }, "Setting": { modal: Setting, name: "Setting" }, "SettingProfile": { modal: SettingProfile, name: "SettingProfile" }, "EditProfile1": { modal: EditProfile1, name: "EditProfile1" }, "EditPassword": { modal: EditPassword, name: "EditPassword" }, "SendLostPassword": { modal: SendLostPassword, name: "SendLostPassword" },
    "SetNewPassword": { modal: SetNewPassword, name: "SetNewPassword" }, "SetProfileIcon": { modal: SetProfileIcon, name: "SetProfileIcon" }, "FixPhoto": { modal: FixPhoto, name: "FixPhoto" }, "SettingPermissions": { modal: SettingPermissions, name: "SettingPermissions" }, "SendFriendInvite": { modal: SendFriendInvite, name: "SendFriendInvite" }, "Contact": { modal: Contact, name: "Contact" }, "Terms": { modal: Terms, name: "Terms" }, "Statistics": { modal: Statistics, name: "Statistics" },
    "FriendList": { modal: FriendList, name: "FriendList" }, "Coupon": { modal: Coupon, name: "Coupon" }, "FriendPage": { modal: FriendPage, name: "FriendPage" }, "Notice": { modal: Notice, name: "Notice" }, "CheckUser": { modal: CheckUser, name: "CheckUser" }, "AddFriend": { modal: AddFriend, name: "AddFriend" }, "Charity": { modal: Charity, name: "Charity" }, "Rank": { modal: Rank, name: "Rank" }, "Tab1Template": { modal: Tab1Template, name: "Tab1Template" },
    "Tab2Template": { modal: Tab2Template, name: "Tab2Template" }, "BottomAlert": { modal: BottomAlert, name: "BottomAlert" }, "JoinRequest": { modal: JoinRequest, name: "JoinRequest" },
    "Loading": { modal: Loading, name: "Loading" }, "PhotoFeeling": { modal: PhotoFeeling, name: "PhotoFeeling" }, "InviteMember": { modal: InviteMember, name: "InviteMember" }, "Invatation": { modal: Invitations, name: "Invitations" }, "UploadAni": { modal: UploadAni, name: "UploadAni" }, "Join": { modal: Join, name: "Join" }
  };

  const preventDefault = useCallback((e) => e.preventDefault(), []);
  useEffect(() => {
    console.log("screenId", screenId)
    console.log("modalType", modalType);
    if (modalType.length === 0) {
      if (screenId.ind === 0 || screenId.ind === 2) {
        document.addEventListener("touchmove", preventDefault, { passive: false });
        listeners.current.push(preventDefault);
      }
      else {
        listeners.current.forEach(listener => {
          document.removeEventListener("touchmove", listener);
        });
        listeners.current = [];
      }
    }
    else {
      const clsName = modalType[modalType.length - 1].cls;
      console.log("clsName", clsName)
      if (["ShareLog"].includes(clsName)) {
        document.addEventListener("touchmove", preventDefault, { passive: false });
        listeners.current.push(preventDefault);
      }
      else {
        listeners.current.forEach(listener => {
          document.removeEventListener("touchmove", listener);
        });
        listeners.current = [];
      }
    }
  }, [screenId, modalType, preventDefault])
  const addModalType = (data) => {
    console.log("addModalType", data);
    if (data.cmd === "delAfter") {
      //刪掉在此modal之後的所有modal
      setModalType(prev => {
        const findIndex = prev.findIndex(v => v.cls === data.cls);
        console.log("findIndex", findIndex);
        if (findIndex !== -1) {
          prev = prev.slice(0, (findIndex + 1));
          return [...prev];
        }
        else {
          return prev;
        }
      });
    }
    else {
      setModalType(prev => {
        // Check if the cls already exists
        if (prev.some(modal => modal.cls === data.cls)) {
          return prev; // If cls exists, return the previous state without changes
        }
        // If cls does not exist, add the new entry
        return [...prev, data];
      });
    }
  };

  useEffect(() => {
    loadData();
  }, [])
  useEffect(() => {
    if (firstLoading)
      set_isLogin(true);
  }, [firstLoading])



  const checkSession = () => {
    console.log("checkSession")
    const apiClient = axios.create({
      baseURL: AppConfig.baseUrl(),
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    apiClient
      .get('/sessions/whoami', {
        withCredentials: true, // 確保攜帶 cookies
      })
      .then((response) => {
        console.log('response:', response);
        const { name, username, picture, email, language } = response.data.identity.traits; // user 基本資料
        apiManager.fetchGet('auth', {}, 0).then(userData => {
          console.log("auth", userData);
          init(userData)
        });
      })
      .catch((err) => {
        console.log('err:', err);
        init()
      });
  }
  async function loadData() {
    let mail = "ulixes6@gmail.com";
    console.log('params', params.size, params.get("type"), params.get("id"))
    if (params.size === 2) {
      if (params.get("type") === "eventInfo") {
        apiManager.fetchGet(`event/${params.get("id")}`, {}, 0).then(res => {
          console.log("res----", res)
          preProcessEvent(res).then(eventVo => {
            console.log("eventVo", eventVo)
            addModalType({
              cls: "EventDetail", arg: {
                cb: () => {
                },
                vo: eventVo
              }
            })
          })
        })
      }
      else if (params.get("type") === "rewildInfo") {
        apiManager.fetchGet(`rewilding/${params.get("id")}`, {}, 0).then(rewildVo => {
          console.log("rewildVo----", rewildVo)
          addModalType({
            cls: "PotDetail", arg: {
              pot: rewildVo
            }
          })
        })
      }
      else if (params.get("type") === "mail") {
        mail = params.get("id");
      }
      else {
        set_prePage({ page: params.get("type"), query: params.get("id") });
      }
    }
    const initStyle = await loadJson('./map_init.json');
    AppConfig.initialMapStyles = initStyle;
    const normalStyle = await loadJson('./map_normal.json');
    AppConfig.normalMapStyles = normalStyle;
    if (AppConfig.sso) {
      checkSession();
    }
    else {
      //set_userData({users_name: "guest", users_username: "遊客", users_id: "0000000000-0000000000-0000000000"})
      await apiManager.fetchPost("auth/email", {
        "email": mail,
        "password": "123456"
      }, 0).then(res => {
        console.log("res", res)
        if (res.message) {
          alert(res.message)
        }
        else {
          apiManager.setToken(res.token);
          init(res.user);
        }
      })
    }
  }

  let BodyContent = useMemo(() => {
    document.title = menuList[screenId.ind];
    switch (screenId.ind) {
      case 0:
        return <Tab0 screenArg={screenId.screenArg} loginData={loginData} set_loginData={set_loginData} addModalType={addModalType} setModalType={setModalType} set_menuVisiable={set_menuVisiable} />
      case 1:
        return <Tab1 screenArg={screenId.screenArg} loginData={loginData} set_loginData={set_loginData} addModalType={addModalType} setModalType={setModalType} set_menuVisiable={set_menuVisiable} />
      case 2:
        return <Tab2 screenArg={screenId.screenArg} loginData={loginData} set_loginData={set_loginData} addModalType={addModalType} setModalType={setModalType} set_menuVisiable={set_menuVisiable} />
      case 3:
        return <Tab3 screenArg={screenId.screenArg} loginData={loginData} set_loginData={set_loginData} addModalType={addModalType} setModalType={setModalType} set_menuVisiable={set_menuVisiable} />
      case 4:
        return <Tab4 screenArg={screenId.screenArg} loginData={loginData} set_loginData={set_loginData} addModalType={addModalType} setModalType={setModalType} set_menuVisiable={set_menuVisiable} />
      case 5:
        return <Tab5 screenArg={screenId.screenArg} loginData={loginData} set_loginData={set_loginData} addModalType={addModalType} setModalType={setModalType} set_menuVisiable={set_menuVisiable} />
    }
  }, [screenId, loginData]);
  let ExternalContent = useMemo(() => {
    if (prePage) {
      switch (prePage.page) {
        case "invite":
          return <Invite query={prePage.query} set_prePage={set_prePage} addModalType={addModalType} />
      }
    }
  }, [prePage]);

  let modalArr = useMemo(() =>
    modalType.map((v, k) => {
      const Component = componentMap[v.cls]["modal"];
      return <Component key={k} arg={v.arg} setModalType={setModalType} addModalType={addModalType} set_menuVisiable={set_menuVisiable} />
    }), [modalType]);
  if (isLoaded)
    return (
      <>
        <div className={style.app} >
          {isLogin &&
            <div className={style.container}>
              {prePage ?
                <div className={style.content}>
                  {ExternalContent}
                </div>
                :
                <div className={style.content}>
                  {BodyContent}
                </div>
              }
              {menuVisiable &&
                <div className={style.menu}>
                  <TabList selectId={screenId.ind} set_selectId={ind => {
                    if (ind === 4 && !userData) {
                      window.location.href = AppConfig.registerUrl();
                    }
                    else
                      set_screenId({ ind: ind })
                  }} list={menuList} ItemCls={MenuItem} />
                </div>
              }
            </div>
          }
        </div>
        {modalArr}
      </>
    );
}


